import src from "IMAGE";
export default { src, width: 201, height: 206, blurWidth: 0, blurHeight: 0};
